import { Directive, HostBinding } from '@angular/core';

@Directive({
    selector: '[appDangerButton]',
    standalone: false
})
export class DangerButtonDirective {
    @HostBinding('class') get classes(): string {
        return 'danger-button-uniform';
    }
}
